import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.css";
import App from "./app.js";
import usePlayerStore from "./stores/player.js";
import useSocketStore from "./stores/socket.js";
import crashReporter from "./crashReporter.js";

async function bootstrap() {
  console.log(`[frontend] branch: ${__GIT_BRANCH__} | commit: ${__GIT_COMMIT__}`);

  try {
    await usePlayerStore.getState().init();
  } catch (err) {
    console.error("Player init failed:", err);
  }

  try {
    await useSocketStore.getState().init();
  } catch (err) {
    console.error("Socket connect failed:", err);
  }

  crashReporter({
    getContext: () => ({
      playerId: usePlayerStore.getState().player?.playerId,
    }),
  });

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();
